import {handleize, unescapeHTML} from "../helpers";

export default {
  template: "#vue-collection",
  delimiters: ["${", "}"],
  props: {
    collection_internal_id: {type: String},
    collection_handle: {type: String},
    collection_type: {type: String},
  },
  data: function () {
    return {
      filters: {brand: [], price: [], collection: []},
      selected_tags: [],
      active_tabs: [],
    };
  },
  methods: {
    sanitize_tag(str) {
      const entities = {
        '$amp': '&',
        '$gt': '>',
        '$lt': '<',
        '$quot': '"',
        '$apos': "'",
        '$plu': "+",
        '$com': ",",
        '$per': "."
      }
      if (str && typeof str === 'string') {
        for (let item of Object.keys(entities)) {
          while (str.includes(item)) {
            str = str.replace(item, entities[item])
          }
        }
      }
      return str
    },
    activateTab: function (tab) {
      if (this.active_tabs.includes(tab)) {
        this.active_tabs = this.active_tabs.filter(e => {
          return e !== tab
        })
      } else {
        this.active_tabs.push(tab);
      }
    },
    handleSort: function (event) {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (
            var aKeyValue, i = 0, aCouples = location.search.substring(1).split("&");
            i < aCouples.length;
            i++
        ) {
          aKeyValue = aCouples[i].split("=");
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1]);
          }
        }
      }
      Shopify.queryParams.sort_by = event.target.value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    },
    handleFilter: function (selection) {
      if (this.selected_tags.includes(selection)) {
        // uncheck selected filter
        this.selected_tags.splice(this.selected_tags.indexOf(selection), 1);
      } else {
        // clear all other filters of the same type since we can't stack multiple
        const tag_split = selection.split("_")
        let tag_type = tag_split[0]
        if (tag_type === "brand" || tag_type === "price" || tag_type === "var") {
          if (tag_type === "var") {
            tag_type += `_${tag_split[1]}_${tag_split[2]}`
          }
          this.selected_tags = this.selected_tags.filter(e => {
            return e.substring(0, tag_type.length + 1) !== `${tag_type}_`
          })
        }
        // check selected filter
        this.selected_tags.push(selection);
      }

      // delay this so there is visible feedback of the radios changing
      let addedTags = this.selected_tags.map(e => {
        return e.replace(/\s/g, '-')
      }).join("+");

      window.location.href =
          `${this.$store.getters.locale_uri_prefix}/collections/${this.collection_handle}/${addedTags}`;
    },
  },
  mounted: function () {
    this.$store.dispatch("getLocation").then(
        success => {
          if (this.collection_handle !== 'all') {
            this.$store.dispatch('getCollectionOrProductsStock', {
              type: 'collection',
              sfs_id: this.collection_internal_id
            })
          }
        },
        () => {
        })

    this.selected_tags = []
    if (collection_tags !== []) {

      // create a brand dict that preserves the original casing
      let brands = {}
      brand_data.map(e => {
        const u = unescapeHTML(e)
        brands[handleize(u)] = u
      })

      collection_tags.map((tag) => {
        tag.tag = unescapeHTML(tag.tag)
        const tag_splits = tag.tag.split("_")
        let tag_type = tag_splits[0];
        let brand_price_text;
        if (tag_type === 'brand' || tag_type === 'price') {
          brand_price_text = tag.tag.substring(tag.tag.indexOf("_") + 1)
        } else if (tag_type === 'var') {
          if (tag_splits.length >= 3) {
            tag_type = `option-${tag_splits[2]}`
          }
        } else {
          tag_type = 'collection'
        }

        if (!!tag.active) {
          this.selected_tags.push(tag.tag)
          let tag_key = (tag_type === 'collection' && tag.tag === 'clearance' ? 'price' : tag_type)
          if (!this.active_tabs.includes(tag_key)) {
            this.active_tabs.push(tag_key)
          }
        }

        if (tag_type === "brand" && this.collection_type !== 'brand') {
          this.filters["brand"].push({
            value: tag.tag,
            text: (handleize(brand_price_text) in brands ? brands[handleize(brand_price_text)] : brand_price_text),
            isChecked: !!tag.active,
          });
        } else if (tag_type === "price") {
          this.filters["price"].push({
            value: tag.tag,
            text: brand_price_text,
            isChecked: !!tag.active,
          });
        } else if (tag.collection_name && tag.tag !== 'clearance') {
          this.filters["collection"].push({
            value: tag.tag,
            text: this.sanitize_tag(tag.collection_name),
            isChecked: !!tag.active,
          });
        } else if (tag_splits[0] === 'var') {
          const elems = tag.tag.split(/_/g)
          if (elems.length >= 4 && elems[1] === this.$store.state.lang) {
            const option = elems[2]
            const text = tag.tag.split(this.$store.state.lang + "_" + option + "_")[1]
            const option_key = `option-${option}`

            if (!(option_key in this.filters)) {
              this.filters[option_key] = []
            }
            this.filters[option_key].push({
              value: tag.tag,
              text: this.sanitize_tag(text),
              isChecked: !!tag.active,
            })
          }
        }
      });

      for (let key of Object.keys(this.filters)) {
        if (key.startsWith("option-")) {
          this.filters[key] = this.filters[key].sort((a, b) => {
            const a1 = parseFloat(a.text)
            const b1 = parseFloat(b.text)
            if (!isNaN(a1) && !isNaN(b1)) {
              if (a1 === b1) {
                return a.text > b.text ? 1 : -1
              } else {
                return a1 > b1 ? 1 : -1
              }
            } else if (!isNaN(a1)) {
              return -1
            } else if (!isNaN(b1)) {
              return 1
            }
            return a.text > b.text ? 1 : -1
          })
        }
      }

      // sort price filters sanely and apply display text
      this.filters["price"] = this.filters["price"].sort((a, b) => {
        let av = parseInt(a.value.split(/_/g)[1])
        let bv = parseInt(b.value.split(/_/g)[1])
        return (av > bv ? 1 : -1)
      }).map(e => {
        const prices = e.text.split(/_/g)
        if (prices.length === 1) {
          e.text = (this.$store.state.lang === 'fr' ? `${prices[0]} $ et plus` : `$${prices[0]} and up`)
        } else {
          e.text = (this.$store.state.lang === 'fr' ? `${prices[0]} $ à ${prices[1]} $` : `$${prices[0]} to $${prices[1]}`)
        }
        return e
      })
    }
  },
}